import { Box, Checkbox, Group, MultiSelect } from '@mantine/core';

export type OS = 'ios' | 'android' | 'other';

const osOptions = [
    { value: 'ios', label: 'iOS' },
    { value: 'android', label: 'Android' },
    { value: 'other', label: 'Other' },
];

export const OSSelector = ({
    id,
    value,
    onChange,
    label,
}: {
    id: string;
    value: string[];
    onChange: (osValues: string[]) => void;
    label?: string;
}) => {
    const allSelected = value.length === osOptions.length;

    // Note: Users can deselect all OS filters, which creates an invalid state
    // that prevents data loading (per spec requirement). This is intentional.
    return (
        <Box>
            <MultiSelect
                id={id}
                label={label}
                value={value}
                onChange={onChange}
                data={osOptions}
                placeholder="All operating systems included"
                clearable={false}
                renderOption={({ option, checked }) => (
                    <Group gap="xs">
                        <Checkbox checked={checked} readOnly tabIndex={-1} size="xs" />
                        {option.label}
                    </Group>
                )}
                comboboxProps={{
                    withinPortal: true,
                    shadow: 'sm',
                }}
            />
            <Box mt={4}>
                <Checkbox
                    size="xs"
                    label={allSelected ? 'Deselect All' : 'Select All'}
                    checked={allSelected}
                    indeterminate={value.length > 0 && !allSelected}
                    onChange={() => {
                        if (allSelected) {
                            onChange([]);
                        } else {
                            onChange(osOptions.map((opt) => opt.value));
                        }
                    }}
                />
            </Box>
        </Box>
    );
};
